'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'envelope';
var width = 512;
var height = 512;
var aliases = [128386,9993,61443];
var unicode = 'f0e0';
var svgPathData = 'M55.9 64C25 64 0 89 0 119.9L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-264.1C512 89 487 64 456.1 64L55.9 64zM496 159l0 225c0 26.5-21.5 48-48 48L64 432c-26.5 0-48-21.5-48-48l0-225c2 2.1 4.2 4 6.6 5.7L213.1 306.1c25.5 18.9 60.3 18.9 85.8 0L489.4 164.8c2.4-1.8 4.6-3.7 6.6-5.7zM16 119.9C16 97.9 33.9 80 55.9 80l400.2 0c22 0 39.9 17.9 39.9 39.9 0 12.6-6 24.5-16.1 32L289.4 293.3c-19.8 14.7-46.9 14.7-66.7 0L32.1 151.9C22 144.4 16 132.5 16 119.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelope = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;